import React from 'react'

import {
	TextField,
	NumberField,
	PrimaryButton,
	InvertedSecondaryButton,
	ButtonsBlock,
}				from '../../Ui'
import Icon		from '../../common/components/Icon'
import Form		from '../../utils/Form'

const RoleForm = ({ roleId, name, number_of_keys, onFieldChange, onDelete, onSubmit }) =>
	<Form onSubmit={onSubmit}>
		<div className="c-role-form u-flex">
			<div className="c-role-form__field u-flex--grow-1">
				<div className="c-role-form__field-header">Nom</div>
				<div className="c-role-form__field-content">
					<TextField
						value={name}
						placeholder="Ex : Maire"
						onChange={(value) => onFieldChange("name", value)} />
				</div>
			</div>
			<div className="c-role-form__field">
				<div className="c-role-form__field-header">Nombre de clés</div>
				<div className="c-role-form__field-content">
					<NumberField
						value={number_of_keys}
						min={1}
						onChange={(value) => onFieldChange("number_of_keys", value)} />
					<Icon icon="key" />
				</div>
			</div>
			<div className="c-role-form__field">
				<div className="c-role-form__field-header">Actions</div>
				<ButtonsBlock>
					<InvertedSecondaryButton
						iconName="bin"
						disabled={!roleId}
						onClick={onDelete}>

						Supprimer
					</InvertedSecondaryButton>
					<PrimaryButton
						iconName="floppy"
						submit>

						Enregistrer
					</PrimaryButton>
				</ButtonsBlock>
			</div>
		</div>
	</Form>

export default RoleForm;



// WEBPACK FOOTER //
// ./src/js/plan/roles/RoleForm.js